import { TextInput } from '@mantine/core';
import { IconFolderPlus } from '@tabler/icons-react';
import { useState } from 'react';
import { FileManagementModal } from './FileManagementModal';

type CreateFolderModalProps = {
  opened: boolean;
  onClose: () => void;
  onCreateFolder: (name: string) => Promise<void>;
};

export function CreateFolderModal({ opened, onClose, onCreateFolder }: CreateFolderModalProps) {
  const [folderName, setFolderName] = useState('');
  const [isCreating, setIsCreating] = useState(false);

  const handleClose = () => {
    setFolderName('');
    setIsCreating(false);
    onClose();
  };

  const handleConfirm = async () => {
    setIsCreating(true);
    try {
      await onCreateFolder(folderName);
      handleClose();
    } finally {
      setIsCreating(false);
    }
  };

  const handleNameChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setFolderName(event.target.value);
  };

  const handleKeyDown = (event: React.KeyboardEvent<HTMLInputElement>) => {
    if (event.key === 'Enter' && folderName.trim() && !isCreating) {
      event.preventDefault();
      handleConfirm();
    }
  };

  return (
    <FileManagementModal
      opened={opened}
      onClose={handleClose}
      title="Create a new folder"
      subtitle="Please enter a name for this folder."
      icon={<IconFolderPlus size={24} />}
      onConfirm={handleConfirm}
      confirmDisabled={!folderName.trim()}
      confirmLoading={isCreating}
    >
      <TextInput
        label="Folder name"
        value={folderName}
        onChange={handleNameChange}
        onKeyDown={handleKeyDown}
        placeholder="e.g. June meeting summary"
        data-autofocus
        styles={{
          label: {
            fontWeight: 500,
          },
        }}
      />
    </FileManagementModal>
  );
}
